import { Drawer, Radio } from 'antd';
import styled from 'react-emotion/macro';
import {
  width, top, bottom, themeGet,
} from 'styled-system';

export const FlexDrawer = styled(Drawer)` &&& {
  z-index: 9999;
  .ant-drawer-close {
    z-index: 996;
  }
  .ant-drawer-title {
    line-height: 14px;
  }

  .ant-drawer-content-wrapper {
    height: calc(100vh - ${themeGet('heights.navBarHeight')});
    ${props => (props.placement === 'bottom') && 'height: 400px !important;'}
    bottom: 0;
    ${width}
    padding: 0;

    .ant-drawer-body {
      padding: 0;
    }
  }

  .ant-timeline {
    margin-top: 48px;
  }

  .ant-timeline-item-content {
    margin-left: 32px;
  }
}`;

export const FlexOptionGroup = styled(Radio.Group)` &&& {
  position: absolute;
  padding: 12px;
  top: 0;
  left: 0;
}`;

export const DrawerHeader = styled('div')` &&& {
  width: 100%;
  height: 50px;
  background: #fff;
  position: absolute;
  ${top}
  ${bottom}
  z-index: 995;
  left: 0;
  top: 0;
  border-bottom: 1px solid ${themeGet('colors.greyscale.3')};
}`;

export const DrawerContent = styled('div')`
  height: calc(100% - 50px);
  width: 100%;
  position: absolute;
  top: 50px;
  left: 0;
  overflow-y: auto;
`;
